import dayjs from 'dayjs';
import { omit } from 'lodash/fp';


const linkRegex = /\b(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})\b/gi;

export const getLinks = (
  title: string,
): Array<string> => (title ? title.match(linkRegex) || [] : []).map(
  (link) => new URL(link.startsWith('http') ? link : `http://${link}`).toJSON(),
);

const regexToFindTimezone = /(\+|\-)\d\d:\d\d$/;

export const discardTimezoneInfo = (dateString: string): Date => dayjs(dateString.replace(regexToFindTimezone, '')).toDate();

export const deserializeTodoItem = (now: Date) => (item: SerializedTodoItem): TodoItem => {
  const postponedUntilPart = item.postponedUntil
          ? { postponedUntil: discardTimezoneInfo(item.postponedUntil) }
          : {},
        links = getLinks(item.title),
        status = item.status === 'postponed' && (postponedUntilPart.postponedUntil || 0) < now
          ? 'todo'
          : item.status,
        lastTimeOfChange = item.lastTimeOfChange ? new Date(item.lastTimeOfChange) : new Date(0),
        manualSortOrder = (item.manualSortOrder || lastTimeOfChange).valueOf(),
        recurringPart = item.recurring
          ? {
            recurring: {
              ...item.recurring,
              nextOccurrence: discardTimezoneInfo(item.recurring.nextOccurrence),
              lastTimeOfChange: new Date(item.recurring.lastTimeOfChange),
            },
          } : {};

  return {
    ...item,
    ...recurringPart,
    ...postponedUntilPart,
    manualSortOrder,
    links,
    lastTimeOfChange,
    status,
  };
};

export const serializeTodoItem = (item: TodoItemDelta): SerializedTodoItemDelta => {
  const postponedUntilPart = item.postponedUntil
          ? { postponedUntil: dayjs(item.postponedUntil).format() }
          : {},
        timeOfChange = dayjs(item.timeOfChange || new Date()).format(),
        recurringPart = item.recurring
          ? {
            recurring: {
              ...item.recurring,
              nextOccurrence: dayjs(item.recurring.nextOccurrence).format(),
              lastTimeOfChange: dayjs(item.recurring.lastTimeOfChange).format(),
            },
          }
          : {};

  return omit(['links'], {
    ...item,
    ...recurringPart,
    ...postponedUntilPart,
    timeOfChange,
  });
};
